export default __webpack_public_path__ + "static/wall-416062_12f80-f319dabf2b7875847aaed48117f296bb.png";